import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, enableNetwork, disableNetwork } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getAnalytics } from 'firebase/analytics';

// Firebase configuration for B.Tech Bawarchi
const firebaseConfig = {
  apiKey: "AIzaSyDwMP5ETeZ_Apv-6Q-A_WfalvxhE7-2-Vg",
  authDomain: "btech-bawarchi-8ec44.firebaseapp.com",
  projectId: "btech-bawarchi-8ec44",
  storageBucket: "btech-bawarchi-8ec44.firebasestorage.app",
  messagingSenderId: "550135016725",
  appId: "1:550135016725:web:e8f54ac4008509495acd1c",
  measurementId: "G-MZJRVYEW7N"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
export const analytics = getAnalytics(app);

// Add connection monitoring
let connectionStatus = 'unknown';

export const checkConnection = async () => {
  try {
    await enableNetwork(db);
    connectionStatus = 'connected';
    console.log('✅ Firebase connection restored');
    return true;
  } catch (error) {
    connectionStatus = 'disconnected';
    console.error('❌ Firebase connection failed:', error);
    return false;
  }
};

export const getConnectionStatus = () => connectionStatus;

// Test Firestore connection
export const testFirestoreConnection = async () => {
  try {
    console.log('🔍 Testing Firestore connection...');
    const { collection, getDocs, limit } = await import('firebase/firestore');
    const testQuery = collection(db, 'food_items');
    const snapshot = await getDocs(testQuery);
    console.log('✅ Firestore connection successful, found', snapshot.size, 'food items');
    
    // Log some sample data to verify connection
    if (snapshot.size > 0) {
      const firstItem = snapshot.docs[0].data();
      console.log('📦 Sample food item:', firstItem.name);
    }
    
    return true;
  } catch (error) {
    console.error('❌ Firestore connection failed:', error);
    console.error('Error details:', {
      code: error.code,
      message: error.message,
      stack: error.stack
    });
    return false;
  }
};

export default app;
